export const duration = 2;
export const color = '#E3E3E3';
export const highlightColor = '#EFF0F1';
export const borderStyleSkeleton = {
    style: {
        borderRadius: '0px',
    },
};

/**
 * This const contain the properties for
 * the skeleton in the financings part.
 */
export const financings = [
    {
        height: 250,
        width: '100%',
    },
    {
        height: 250,
        width: '100%',
    },
];

/**
 * This const contain the properties for
 * the skeleton in the selectors part.
 */
export const selectors = [
    {
        height: 20,
        class: 'title-selector',
        marginTop: '0px',
    },
    {
        height: 40,
        class: 'content-selector',
        marginTop: '-13px',
    },
    {
        height: 20,
        class: 'title-selector-1',
        marginTop: '0px',
    },
    {
        height: 40,
        class: 'content-selector',
        marginTop: '-13px',
    },
];

/**
 * This const contain the properties for
 * the skeleton in the costs part.
 */
export const costs = [
    {
        height: 20,
        class: 'total-text',
        marginTop: '-20px',
    },
    {
        height: 30,
        class: 'total-number',
        marginTop: '-13px',
    },
    {
        height: 20,
        class: 'total-text',
        marginTop: '-13px',
    },
    {
        height: 30,
        class: 'total-number',
        marginTop: '-13px',
    },
];
